var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMagic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.638 2.89139C15.4573 2.07201 16.7858 2.07201 17.6052 2.89139C18.4246 3.71076 18.4246 5.03923 17.6052 5.8586L6.35519 17.1086C5.53581 17.928 4.20734 17.928 3.38797 17.1086C2.56859 16.2892 2.56859 14.9608 3.38797 14.1414L14.638 2.89139ZM16.7213 3.77527C16.3901 3.44405 15.8531 3.44405 15.5219 3.77527L13.2555 6.04166L14.4549 7.24111L16.7213 4.97472C17.0525 4.6435 17.0525 4.10649 16.7213 3.77527Z",
    fill: "#0e131c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.70661 1.72889C8.78725 1.68857 8.85263 1.62318 8.89295 1.54255L9.29149 0.745464C9.44504 0.438361 9.88329 0.438361 10.0369 0.745464L10.4354 1.54255C10.4757 1.62318 10.5411 1.68857 10.6218 1.72889L11.4189 2.12743C11.726 2.28098 11.726 2.71923 11.4189 2.87278L10.6218 3.27133C10.5411 3.31164 10.4757 3.37703 10.4354 3.45767L10.0369 4.25475C9.88329 4.56185 9.44504 4.56185 9.29149 4.25475L8.89295 3.45767C8.85263 3.37703 8.78725 3.31164 8.70661 3.27133L7.90952 2.87278C7.60242 2.71923 7.60242 2.28098 7.90952 2.12743L8.70661 1.72889Z",
    fill: "#0e131c"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2065 10.8954C16.2872 10.8551 16.3526 10.7897 16.3929 10.7091L16.7914 9.91197C16.945 9.60486 17.3832 9.60486 17.5368 9.91197L17.9353 10.7091C17.9756 10.7897 18.041 10.8551 18.1217 10.8954L18.9188 11.294C19.2259 11.4475 19.2259 11.8858 18.9188 12.0393L18.1217 12.4379C18.041 12.4782 17.9756 12.5436 17.9353 12.6242L17.5368 13.4213C17.3832 13.7284 16.945 13.7284 16.7914 13.4213L16.3929 12.6242C16.3526 12.5436 16.2872 12.4782 16.2065 12.4379L15.4095 12.0393C15.1024 11.8858 15.1024 11.4475 15.4095 11.294L16.2065 10.8954Z",
    fill: "#0e131c"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.53962 5.89539C4.62026 5.85507 4.68564 5.78969 4.72596 5.70905L5.1245 4.91197C5.27806 4.60487 5.71631 4.60487 5.86986 4.91197L6.2684 5.70905C6.30872 5.78969 6.3741 5.85507 6.45474 5.89539L7.25183 6.29394C7.55893 6.44749 7.55893 6.88574 7.25183 7.03929L6.45474 7.43783C6.3741 7.47815 6.30872 7.54354 6.2684 7.62417L5.86986 8.42126C5.71631 8.72836 5.27806 8.72836 5.1245 8.42126L4.72596 7.62417C4.68564 7.54354 4.62026 7.47815 4.53962 7.43783L3.74254 7.03929C3.43543 6.88574 3.43543 6.44749 3.74254 6.29393L4.53962 5.89539Z",
    fill: "#0e131c"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagic);
export default __webpack_public_path__ + "static/media/magic.a89c35d2603562a563090973d1e941ee.svg";
export { ForwardRef as ReactComponent };